import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { RealtimeProvider } from './contexts/RealtimeContext';

function App() {
  return (
    <AuthProvider>
      <RealtimeProvider>
        <Routes />
      </RealtimeProvider>
    </AuthProvider>
  );
}

export default App;